import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';

function DynamicDropdown({
  id,
  className,
  required,
  selectedValue,
  onChange,
  options,
  placeholder,
  optionLabel,
  disabled = false
}) {
  const { t } = useTranslation();
  return  (
    <Dropdown
      id={id}
      className={className}
      optionLabel={optionLabel}
      value={selectedValue}
      required={required}
      onChange={onChange}
      placeholder={t(placeholder)}
      disabled={disabled}
      options={options}
    />
  );
}

export default DynamicDropdown;
